/* eslint-disable */
import _ from "lodash/fp";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaRegClipboard } from "react-icons/fa6";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  generateCaptcha,
  getActiveSlideShowAdvt,
  getAppVersion,
  getDigilockerAccessToken,
  getDigilockerAccessToken2,
  getGuidelineLinks,
  getHelplineDetails,
  loginAction
} from "../../common/actions/commonActions";
import commonLabels from "../../common/labels/common_en.json";
import { legacyLoginFunction } from "../../registration_login/actions/registrationActions";
import {
  onCaptchaProceed
} from "../../registration_login/actions/sessionActions";
import "../../styles/candidate_nav.css";
import "../../styles/home.css";
import "../../styles/profile.css";
import "../../styles/registration.css";
import commonEnLabels from "../labels/common_en.json";
import AdvertisementSlideShow from "./AdvertisementSlideShow";
import { Modal } from "react-bootstrap";

const Home = (props) => {
  const location = useLocation();

  // Parse query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const navigate = useNavigate();
  let accessToken = useSelector((state) => state.loginReducer.accessToken);
  let digiuserEmail = sessionStorage.getItem("userEmail") || '';
  let digiuserHscYear = sessionStorage.getItem("userHscYear") || '';
  let digiuserHscBoard = sessionStorage.getItem("userHscBoard") || '';
  let digiuserHscRollNo = sessionStorage.getItem("userHscRollNo") || '';
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let sessionToken = session && session.jwtResponse.token;
  let profileId = sessionStorage.getItem("profileId") || '';
  const guidelinesLinks = useSelector((state) => state.common.guidelineLinks);
  const getHelpLineList = useSelector((state) => state.common.getHelpLineList);
  const dispatch = useDispatch();

  const { register, handleSubmit, formState, errors, watch } = useForm({
    mode: "onChange",
  });
  const captchaId = useSelector((state) => state.common.captchaId);

  const [data, setData] = useState({});
  let [forceFulLogout, setForceFulLogout] = useState(false);
  let [forceFulLogoutErrorMessage, setForceFulLogoutErrorMessage] =
    useState(false);
  let [usernameForLogin, setUsernameForLogin] = useState(false);
  let [showCaptcha, setShowCaptcha] = useState(false);
  let [details, setDetails] = useState();
  let [userDetail, setUserDetail] = useState();
  const [saveButton, setSaveButton] = useState(false)
  const [showAllAdvt, setShowAllAdvt] = useState(false);
  const currentDomain = window.location.hostname;
  const captchaImageUrl = `/oas/api/v1/otps/${captchaId}`;


  const [showModal, setShowModal] = useState(false);
  const [modalActions, setModalActions] = useState({ onOk: () => { }, onCancel: () => { } });

  const [modalAllReadyLogin, setModalAllReadyLogin] = useState(false);
  const [modalActionsAllReadyLogin, setModalActionsAllReadyLogin] = useState({ onOk: () => { }, onCancel: () => { } });
  const [allReadyLoginMsg, setAllReadyLoginMsg] = useState("");

  const { advertisementList, showAdvertisementDetails } = useSelector(
    (state) => state.advertisement,
    shallowEqual
  );

  const { activeAdvtSlideShowList } = useSelector((state) => state.common, shallowEqual)
  useEffect(() => {
    if ((code != null && digiuserEmail != null && digiuserHscYear != null && digiuserHscBoard != null && digiuserHscRollNo != null) && (code != "" && digiuserEmail != "" && digiuserHscYear != "" && digiuserHscBoard != "" && digiuserHscRollNo != "")) {
      dispatch(getDigilockerAccessToken(code, digiuserEmail, digiuserHscYear, digiuserHscBoard, digiuserHscRollNo));
    }
  }, [code, digiuserEmail, digiuserHscYear, digiuserHscBoard, digiuserHscRollNo]);


  useEffect(() => {

    if ((code != null && (accessToken != null || sessionToken != null)) && (code != "" && (accessToken != "" || sessionToken != ""))) {
      dispatch(getDigilockerAccessToken2(code, navigate));
    }
    dispatch(getActiveSlideShowAdvt());

  }, [code, accessToken, sessionToken]);


  useEffect(() => {
    localStorage.setItem("advtList", JSON.stringify(advertisementList))
  }, [])


  useEffect(() => {
    dispatch(getGuidelineLinks());
    dispatch(getHelplineDetails());
    dispatch(getAppVersion())
    const preventClipboardActions = (event) => {
      if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
        event.preventDefault();
      }
    };
    document.addEventListener("copy", preventClipboardActions);
    document.addEventListener("cut", preventClipboardActions);
    document.addEventListener("paste", preventClipboardActions);
    return () => {
      document.removeEventListener("copy", preventClipboardActions);
      document.removeEventListener("cut", preventClipboardActions);
      document.removeEventListener("paste", preventClipboardActions);
    };
  }, []);

  // useEffect(() => {
  //   const preventClipboardActions = (event) => {
  //     event.preventDefault();
  //   };
  //   document.addEventListener("copy", preventClipboardActions);
  //   document.addEventListener("cut", preventClipboardActions);
  //   document.addEventListener("paste", preventClipboardActions);
  //   return () => {
  //     document.removeEventListener("copy", preventClipboardActions);
  //     document.removeEventListener("cut", preventClipboardActions);
  //     document.removeEventListener("paste", preventClipboardActions);
  //   };
  // }, [])


  useEffect(() => {
    if (accessToken || (sessionToken)) {
      // navigate("/candidate/main");
      // window.location.href = "/candidate/main";
    }
  }), [accessToken, sessionToken]

  // if (accessToken || (session && session.jwtResponse.token)) {
  //   console.log(11, 'test');
  //   // navigate("/candidate/main");
  //   // return (
  //   //   <div>
  //   //     <h6 className="d-flex justify-content-center bold-text">
  //   //       {commonLabels.HOME.YOU_ARE_LOGGED_IN}&nbsp;
  //   //       <Link
  //   //         onClick={() => {
  //   //           dispatch(logout(props, true, navigate));
  //   //         }}
  //   //       >
  //   //         {commonLabels.BUTTONS.LOGOUT}
  //   //       </Link>
  //   //       &nbsp;{commonLabels.HOME.TO_VIEW_PAGE_NOTE}&nbsp;
  //   //       <Link to="/candidate/main">{commonLabels.HOME.APPLICATION}</Link>.
  //   //     </h6>
  //   //   </div>
  //   // );
  // }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onProceed();
    }
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleKeyDownLogin = (event) => {
    if (event.key === "Enter") {
      dispatch(
        loginAction(
          data,
          // emailOTPResponse,
          setShowCaptcha,
          setForceFulLogout,
          setForceFulLogoutErrorMessage,
          setUsernameForLogin
        )
      );
    }
  };

  useEffect(() => {
    if ((typeof (data.userName) === "string" && data.userName.startsWith("2000")) && (data.Password?.length > 5)) {
      setTimeout(() => {
        setSaveButton(true);
      }, 2000)
    }

    if (typeof (data.userName) === "string" && !data.userName.startsWith("2000")) {
      setSaveButton(true)
    }
  }, [data.userName, data.Password])

  const handleSubmits = (event) => {
    event.preventDefault();

    if (typeof (data.userName) === "string" && data.userName.startsWith("2000")) {

      legacyLoginFunction(data.userName, data.Password);
      return;
    } else {
      dispatch(
        loginAction(
          data,
          // emailOTPResponse,
          setShowCaptcha,
          setForceFulLogout,
          setForceFulLogoutErrorMessage,
          setUsernameForLogin
        )
      );
      setUserDetail(data);
    }
  };

  const onProceed = () => {
    dispatch(onCaptchaProceed(props, details, captchaId, userDetail, setShowModal, setModalActions, setModalAllReadyLogin, setModalActionsAllReadyLogin, setAllReadyLoginMsg, navigate));
  };
  return (
    <div>
      <div className="row margin5">
        <div className="col-sm-12 col-md-3 boxCommonCss">
          {(getHelpLineList && getHelpLineList.length > 0) &&
            <div className="boxCss responsive_helpline">
              <div className="helpLineDivCss align-middle">
                <span>
                  <img src="/icons/vector.png" className="icons w8 "></img> &nbsp;
                  {commonLabels.HOME.BPSE_HELP_LINE}
                </span>
              </div>
              <p className="bpscHelpLineParaCss"></p>
              <div className="bpscHelpLineDivCss">
                {getHelpLineList[0].note && <div className=" neg-mt-5 text-danger ml7 mb-2">{getHelpLineList[0].note}
                </div>}
                <div className="ml7 mb2 text-primary">
                  <img src="/icons/phone.png" className="icons w8"></img> &nbsp;
                  {getHelpLineList[0].primaryNo}
                  {getHelpLineList[0].primaryNo && getHelpLineList[0].secondaryNo && '/'}
                  {getHelpLineList[0].secondaryNo}
                </div>
                {getHelpLineList[0].email && <div className="ml7 text-primary">
                  <img src="/icons/email.png" className="icons w8"></img> &nbsp;
                  {getHelpLineList[0].email}
                </div>}

                <div className="mt10 ms-2">
                  <img src="/icons/support.png" className="icons w8"></img> &nbsp;
                  <span className="text-danger fw-bold">
                    {commonLabels.HOME.SUPPORT_TIMING}
                  </span>
                  <br />
                  <span>{getHelpLineList[0].weekdays}</span>
                  <br />
                  <span>{getHelpLineList[0].weekends}</span>
                </div>
              </div>
            </div>
          }
          <div className="boxCss responsive_guidelines">
            <div className="helpLineDivCss text-center">
              <img src="/icons/guidelines.png" className="icons w8"></img>{" "}
              &nbsp;
              {commonLabels.HOME.GUIELINES_FOR_CANDIDATE}{" "}
            </div>
            <p className="bpscHelpLineParaCss"></p>
            <div className="bpscHelpLineDivCss ">
              {
                <p className="lh30">
                  {guidelinesLinks &&
                    guidelinesLinks.map((ele, index) => {
                      const labelText = ele.label.split("(");
                      const firstPart = labelText[0];
                      const secondPart = labelText[1] ? `(${labelText[1]}` : "";
                      return (
                        <span key={index}>
                          <img src="/icons/file-pdf-regular.png" className="icons w6"></img>
                          &nbsp;
                          <a href={ele.href} target="_blank" className="textDecorationCss">
                            <span className="text-primary">{firstPart}</span>
                            <span className="text-danger">{secondPart}</span>
                          </a>
                          <br />
                        </span>
                      )
                    })}
                </p>
              }
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 position-relative1">
          <img src="/icons/home.png" className="img-responsive"></img>
          <div className="overlay-text">
    <span className="home-text ">
              {commonLabels.HOME.WELCOME_MES_NOTE_1}</span>
      <br />
    <span className="home-text font-weight-500">
              {commonLabels.HOME.WELCOME_MES_NOTE_2}
            </span>
          </div>
        </div>

        <div className="col-sm-12 col-md-3 login-form">
          <div className={`${activeAdvtSlideShowList.length >= 1 ? "" : "h85"} boxCss`}>
            <div className="helpLineDivCss text-center">
              <img src="/icons/account-box.png" className="icons w8"></img>{" "}
              &nbsp;
              {commonLabels.SIGN_IN.LOGIN}
            </div>
            <p className="bpscHelpLineParaCss"></p>
            <form className="" onSubmit={handleSubmits}>
              <div className="bpscHelpLineDivCss ">
                {!showCaptcha ? (
                  <>
                    <div className="form-group col-md-12">
                      <label className="f14 font-weight">
                        {commonLabels.SIGN_IN.REGISTERED_EMAIL_OR_MOBILE}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <span className="input-group-text login-input-border-color">
                          <i className="far fa-user"></i>
                        </span>
                        <input
                          type="text"
                          placeholder={commonLabels.SIGN_IN.REGISTERED_EMAIL_OR_MOBILE_PLACEHOLDER}
                          className="form-control f10 no-border login-input-border-color box-shadow-none"
                          id="userName"
                          name="userName"
                          ref={register({
                            required: true,
                            validate: {
                              email: (value) =>
                                /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/.test(
                                  value
                                ) || /^\s*([1-9]{1}[0-9]{9})\s*$/.test(value) ||
                                /^\s*(2000\d{0,9})\s*$/.test(value)
                            },
                          })}
                          onChange={handleInputChange}
                        // onCopy={(e) => e.preventDefault()}
                        // onCut={(e) => e.preventDefault()}
                        // onPaste={(e) => e.preventDefault()}
                        />
                      </div>
                      {_.get("userName.type", errors) === "required" && (
                        <p className="errorText f11">
                          {commonLabels.VALIDATE_MESSAGE.USERNAME_REQ}
                        </p>
                      )}
                      {errors.userName?.type === "email" && (
                        <p className="errorText f11">
                          {commonLabels.SIGN_IN.VALID_VALUE_NOTE}{" "}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-12">
                      <label className="f14 font-weight">
                        {commonLabels.SIGN_IN.PASSWORD}
                        <span className="errorText">*</span>
                      </label>
                      <div className="input-group bg-color">
                        <span className="input-group-text login-input-border-color">
                          <i className="fas fa-lock"></i>
                        </span>
                        <input
                          type="password"
                          className="form-control f10 no-border borderRadius10 box-shadow-none"
                          id="password"
                          name="Password"
                          placeholder={commonLabels.SIGN_IN.ENTER_PASSWORD}
                          ref={register({ required: true })}
                          onKeyDown={handleKeyDownLogin}
                          disabled={
                            errors.userName?.type === "email" ||
                            _.get("userName.type", errors) ||
                            !watch("userName")
                          }
                          onChange={handleInputChange}
                        // onCopy={(e) => e.preventDefault()}
                        // onCut={(e) => e.preventDefault()}
                        // onPaste={(e) => e.preventDefault()}
                        />
                      </div>
                      {_.get("Password.type", errors) === "required" && (
                        <p className="errorText">
                          {commonLabels.VALIDATE_MESSAGE.PASSWORD_REQ}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-12">
                      <div className="input-group">
                        <button
                          type="submit"
                          disabled={!formState.isValid || !saveButton}
                          className=" btn btn-primary custom_button  button-gradient borderRadius10 mt-2 mb-2"
                        >
                          {commonLabels.SIGN_IN.LOGIN}
                        </button>
                      </div>
                      {/* {(!formState.isValid || !saveButton) && (
                        <span className="errorText text-center">Please fill mandatory fields first</span>
                      )} */}

                    </div>
                  </>
                ) : (
                  <div className="row d-flex justify-content-center">
                    <div className="form-group col-md-11 background-field">
                      {/* {captchaId !== 0 && matchingBaseUrl ? (
                      <img src={captchaImageUrl} id="captchaimage" />
                    ) : captchaId !== 0 ? ( */}
                      {captchaId !== 0 ? (
                        <img src={captchaImageUrl} id="captchaimage" />
                      ) : captchaId !== 0 ? (
                        <img
                          src={`/oas/api/v1/otps/${captchaId}`}
                          id="captchaimage"
                        />
                      ) : (
                        ""
                      )}
                      <span className="ms-2">
                        {" "}
                        <i
                          className="fa fa-refresh fa-lg cursor-pointer"
                          onClick={() => {
                            dispatch(generateCaptcha());
                          }}
                        />
                      </span>
                      <label className="LeftText">
                        {" "}
                        {commonLabels.SIGN_IN.ENTER_THE_TEXT_AS_ABOVE_IMAGE}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        id="exampleFormControlInput2"
                        name="enteredCaptcha"
                        autoComplete="off"
                        ref={register({ required: true })}
                        onChange={(e) => setDetails(e.target.value)}
                        onKeyDown={handleKeyDown}
                      // onCopy={(e) => e.preventDefault()}
                      // onCut={(e) => e.preventDefault()}
                      // onPaste={(e) => e.preventDefault()}
                      />
                      {_.get("enteredCaptcha.type", errors) === "required" && (
                        <p className="errorText">
                          {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-9 d-flex justify-content-center">
                      <button
                        type="button"
                        disabled={!formState.isValid}
                        className=" btn btn-primary custom_button "
                        onClick={onProceed}
                      >
                        {commonLabels.BUTTONS.Proceed}
                      </button>
                    </div>
                  </div>
                )}
                {/* <div className="col-md-12 d-flex justify-content-center">
                  <img
                    src="/icons/registration.jpg"
                    className="registration-icon"
                  ></img>
                </div> */}
                <div className="col-md-12 d-flex justify-content-center mt-4">
                  <Link
                    to="/candidate/registration"
                    className="f13 textDecorationCss"
                  >
                    {commonLabels.HOME.NEW_USER_REGISTRATION}
                  </Link>
                </div>
                <div className="col-md-12 d-flex justify-content-center">
                  <Link
                    to="/candidate/forgotPassword"
                    className="f13 textDecorationCss"
                  >
                    {commonLabels.HOME.FORGOT_OR_RESET_PASSWORD}
                  </Link>
                </div>
                {/* To redirect old Website  */}
                <div className="col-md-12 d-flex justify-content-center">
                  <Link
                    to={commonLabels.HOME.FORGOT_OR_RESET_PASSWORD_OF_OLD_WEB_LINK}
                    className="f13 textDecorationCss"
                  >
                    {commonLabels.HOME.FORGOT_OR_RESET_PASSWORD_OF_OLD_WEB}
                  </Link>
                </div>
                {/* <div className="col-md-12 d-flex justify-content-center pt-2">
                  <Link
                    to={commonLabels.HOME.BPSC_OFFICIAL_WEBSITE_LINK}
                    className="f13 textDecorationCss"
                    target="_blank" >
                    {commonLabels.HOME.BPSC_OFFICIAL_WEBSITE}
                  </Link>
                </div> */}
                {/* <div className="col-md-12 d-flex justify-content-center">
                  <Link
                    to="/candidate/forgotEmailMobile"
                    className="f15 textDecorationCss text-center"
                  >
                    {
                      commonLabels.HOME
                        .FORGOT_OR_RESET_EMAIL_ID_AND_MOBILE_NUMBER
                    }
                  </Link>
                </div> */}
              </div>
            </form>

            <Modal show={showModal} onHide={modalActions.onCancel} centered>
              <Modal.Header className="logout_heading">
                <Modal.Title className="logout_title">{commonEnLabels.DigiLocker_Confirmation}</Modal.Title>
                <button
                  type="button"
                  className="ms-auto logout_close"
                  aria-label="Close"
                  onClick={modalActions.onCancel}
                >X</button>

              </Modal.Header>
              <Modal.Body>
                {commonLabels.COMMON.DIGILOCKER_CONFIRMATION_MES}
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-primary" onClick={modalActions.onOk}>{commonEnLabels.BUTTON_YES}</button>
                <button className="btn btn-secondary" onClick={modalActions.onCancel}>{commonEnLabels.BUTTON_NO}</button>
              </Modal.Footer>
            </Modal>


            <Modal show={modalAllReadyLogin} onHide={modalActionsAllReadyLogin.onCancel} centered >
              <Modal.Header className="logout_heading">
                <Modal.Title className="logout_title">{commonEnLabels.You_Are_Already_Logged_In}</Modal.Title>
                <button
                  type="button"
                  className="ms-auto logout_close"
                  aria-label="Close"
                  onClick={modalActionsAllReadyLogin.onCancel}
                >X</button>

              </Modal.Header>
              <Modal.Body>
                {allReadyLoginMsg}
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-primary" onClick={modalActionsAllReadyLogin.onOk}>{commonEnLabels.BUTTON_YES}</button>
                <button className="btn btn-secondary" onClick={modalActionsAllReadyLogin.onCancel}>{commonEnLabels.BUTTON_NO}</button>
              </Modal.Footer>
            </Modal>
          </div>
          {activeAdvtSlideShowList.length >= 1 && < div className="boxCss">
            <div className="">
              <div className="noticeDivCss">
                <FaRegClipboard size={20} />
                &nbsp;
                <span>{commonEnLabels.IMPORTANT_NOTICES}</span>
                {/* <div className="button-container"> */}
                <button className="view-all-btn" onClick={() => setShowAllAdvt(true)}>
                  {commonEnLabels.VIEW_ALL_BTN}
                </button>
                {/* </div> */}
              </div>
            </div>
            <p className="bpscHelpLineParaCss"></p>
            <div className="bpscHelpLineDivCss">
              <AdvertisementSlideShow showAllAdvt={showAllAdvt} setShowAllAdvt={setShowAllAdvt} activeAdvtSlideShowList={activeAdvtSlideShowList} />
            </div>
          </div>}
        </div>
      </div >


    </div >
  );
};

export default Home;
